<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space add-catalog-dialog">

    <sc-dialog-title>
      {{ 'Add projectpart' | translate: ['erp.ui.add-projectpart.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>
    <sc-padding>
        <div style="width: 450px;">
            <form [formGroup]="formGroup">
                <mat-form-field appearance="fill" style="width: 100%">
                    <mat-label>{{ 'Name' | translate: ['erp.entity.projectpart.name',
                        translationService.language]}}</mat-label>
                    <input matInput formControlName="name" required="true">
                </mat-form-field>
            </form>
        </div>
    </sc-padding>
    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          {{ 'Abbrechen' | translate: ['erp.ui.add-projectpart.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled">
          {{ 'Übernehmen' | translate: ['erp.ui.add-projectpart.action.confirm', translationService.language]}}
        </button>
    </sc-actionbar>
</sc-flex>
